class ProductSlider extends HTMLElement {
  constructor() {
    super();
    this.initSwiper();
  }

  initSwiper() {
    const { Swiper } = window;
    this.swiper = new Swiper(".swiper-container", {
      slidesPerView: "auto",
      spaceBetween: 20,
      nested: true,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
  }
}

customElements.define('product-slider', ProductSlider);